<ion-toolbar>
  <ion-title>{{ "modals.voucher_modal.header" | translate }}</ion-title>
</ion-toolbar>

<ion-content class="block">
  <div class="ion-padding">
    <div *ngFor="let voucherDetail of vouchersInfo; let i = index">
      <div class="ion-padding-bottom">
        <ion-card
          class="border-r10 ion-no-margin card-white-background-color pad10 grid-container grey-border"
        >
          <ion-text
            class="fs-4 font600 ion-no-padding card-primary-text-color pad10"
            *ngIf="totalVouchers > 1" 
          >
            {{ i + 1 }}/{{ totalVouchers }}
          </ion-text>
          <div class="ion-text-center d-flex flex-col">
            <ion-text
              class="fs-4 font600 ion-no-padding card-primary-text-color"
            >
              {{ voucherDetail?.vouchers?.[0]?.code }}
            </ion-text>
            <ion-text
              class="fs-1 font500 ion-no-padding card-primary-text-color"
            >
              {{ "modals.voucher_modal.expiry" | translate }} -
              {{ voucherDetail?.vouchers?.[0]?.endDate | smartdate }}
            </ion-text>
          </div>
          <ion-icon
            [name]="copiedStates[i] ? 'checkmark-outline' : 'copy-outline'"
            class="ion-float-right primary-icon-color fs-4 pad10"
            (click)="copyToClipboard(voucherDetail?.vouchers?.[0]?.code, i)"
          ></ion-icon>
        </ion-card>
      </div>
    </div>
    <div *ngIf="allowBooking">
      <ion-button
        expand="block"
        class="secondary-btn mart10"
        (click)="generateVoucherTrigger()"
      >
        <div class="btn_container">
          <p class="fs-3 font600 no-margin-bottom no-margin-top">
            {{ "modals.voucher_modal.generate_voucher" | translate }}
          </p>
          <ion-icon name="chevron-forward-outline" class="fs-3"></ion-icon>
        </div>
      </ion-button>
    </div>
  </div>
</ion-content>

<ion-footer class="padb5">
  <ion-toolbar class="pad5 ion-bg-white">
    <ion-button
      expand="block"
      class="primary-btn book-btn fs-3 font500"
      (click)="redeemCode()"
    >
      {{ "modals.voucher_modal.redeem_code" | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
